import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../lib/constants";

const HEADER_ANIM = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
  transition: { duration: 0.7 },
};

const CARD_ANIM = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

export default function Reviews() {
  return (
    <section
      id="avis"
      data-testid="reviews-section"
      className="relative py-24 md:py-32 bg-[#050505] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          {...HEADER_ANIM}
          className="mb-16 md:flex md:items-end md:justify-between gap-12"
        >
          <div className="max-w-2xl">
            <div className="eyebrow mb-4">Avis vérifiés</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-light leading-tight">
              <em className="text-[#FF5A00] not-italic font-normal">5,0/5</em>
              <br />
              sur Google.
            </h2>
          </div>
          <div className="flex items-center gap-2 mt-6 md:mt-0">
            {[...Array(5)].map((_, i) => (
              <Star key={`hero-star-${i}`} size={22} className="fill-[#FF5A00] text-[#FF5A00]" />
            ))}
            <span className="ml-3 text-neutral-400 text-sm">
              Basé sur 87 avis clients
            </span>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={`${t.name}-${t.city}`}
              {...CARD_ANIM}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`testimonial-${i}`}
              className="glass rounded-2xl p-8 relative hover:border-white/20 transition-all"
            >
              <Quote
                size={28}
                className="text-[#FF5A00]/40 absolute top-6 right-6"
              />
              <div className="flex items-center gap-1 mb-4">
                {[...Array(t.rating)].map((_, j) => (
                  <Star key={`${t.name}-star-${j}`} size={14} className="fill-[#FF5A00] text-[#FF5A00]" />
                ))}
              </div>
              <p className="font-display text-lg text-white leading-snug mb-6 italic">
                « {t.text} »
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-white/10">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#FF5A00] to-[#E55100] flex items-center justify-center font-medium">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm text-white font-medium">{t.name}</div>
                  <div className="text-xs text-neutral-500">{t.city}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
